import React from 'react';
import { Outlet, Navigate, ScrollRestoration } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Navigation } from './Navigation';

export const Layout: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <ScrollRestoration />
      <Navigation />
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-white focus:p-3">Zum Inhalt</a>
      <main id="main-content" className="app-content pt-20" tabIndex={-1}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
